var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVirtualnotary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5484 0.0976562L18.8945 8.78981H33.4459V0.822002C33.4459 0.42197 33.1216 0.0976562 32.7215 0.0976562H30.5484Z",
    fill: "#B8D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5508 0.822002V8.78981H30.5508V0.0976562H15.2751C14.875 0.0976562 14.5508 0.42197 14.5508 0.822002Z",
    fill: "#DBEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0029 5.89242C25.603 5.89242 26.9002 4.59522 26.9002 2.99504C26.9002 1.39486 25.603 0.0976562 24.0029 0.0976562C22.4027 0.0976562 21.1055 1.39486 21.1055 2.99504C21.1055 4.59522 22.4027 5.89242 24.0029 5.89242Z",
    fill: "#3D5168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7802 5.89258H37.8828V40.6979L40.7802 34.9031C42.3738 34.9031 43.6776 33.5993 43.6776 32.0057V8.78996C43.6776 7.1964 42.3738 5.89258 40.7802 5.89258Z",
    fill: "#3D5168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24113 5.89258C5.64757 5.89258 4.34375 7.1964 4.34375 8.78996V31.969C4.34375 33.5626 5.64757 34.8664 7.24113 34.8664L23.9977 40.6612L37.8568 34.8664C39.4504 34.8664 40.7542 33.5626 40.7542 31.969V8.78996C40.7542 7.18974 39.457 5.89258 37.8568 5.89258H30.5489L23.9977 7.34127L17.4464 5.89258H7.24113Z",
    fill: "#57697D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4453 5.89258C17.4453 7.4929 18.7424 8.78996 20.3427 8.78996L23.9966 11.6873L27.6505 8.78996C29.2508 8.78996 30.5478 7.4929 30.5478 5.89258H17.4453Z",
    fill: "#B8D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.957 40.6602V47.9036H45.1017C46.7019 47.9036 47.999 46.6065 47.999 45.0062L41.957 40.6602Z",
    fill: "#3D5168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58883 42.1094L0 45.0068C0 46.607 1.29716 47.9042 2.89738 47.9042H41.958C43.5582 47.9042 44.8554 46.607 44.8554 45.0068V42.1094H7.58883Z",
    fill: "#57697D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.405 36.6211C43.9491 35.5558 42.9012 34.8652 41.7423 34.8652H38.5977L44.8541 45.0061H47.9987L44.405 36.6211Z",
    fill: "#B8D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2616 36.6211L41.7434 37.7626L39.4733 39.2086L42.9915 40.66L44.8554 45.0061H0L3.59372 36.6211C4.04958 35.5558 5.09746 34.8652 6.25642 34.8652H38.599C39.7579 34.8652 40.8048 35.5558 41.2616 36.6211V36.6211Z",
    fill: "#DBEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9922 40.6591L41.7441 37.7617H6.25735L5.01562 40.6591H42.9922Z",
    fill: "#57697D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9978 3.71822C24.3978 3.71822 24.7221 3.39392 24.7221 2.99388C24.7221 2.59383 24.3978 2.26953 23.9978 2.26953C23.5977 2.26953 23.2734 2.59383 23.2734 2.99388C23.2734 3.39392 23.5977 3.71822 23.9978 3.71822Z",
    fill: "#1E8AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7546 31.9681H37.8573L32.0625 20.3786L37.8573 8.78906H40.7546V31.9681Z",
    fill: "#BAE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24609 8.78906H37.8618V31.9681H7.24609V8.78906Z",
    fill: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1005 23.2773H26.2031L29.1005 29.0721H31.9979V26.1747C31.9979 24.5812 30.6941 23.2773 29.1005 23.2773Z",
    fill: "#1B74D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8974 23.2773C17.3038 23.2773 16 24.5812 16 26.1747V29.0721H18.8974L21.7948 23.2773H18.8974Z",
    fill: "#54A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2063 23.2773H21.7958C20.2023 23.2773 18.8984 24.5812 18.8984 26.1747V29.0721H29.1036L29.1037 26.1747C29.1037 24.5812 27.7999 23.2773 26.2063 23.2773V23.2773Z",
    fill: "#1E8AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9688 11.6875V20.3797C26.369 20.3797 28.3148 18.4339 28.3148 16.0336C28.3148 13.6333 26.369 11.6875 23.9688 11.6875Z",
    fill: "#1B74D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4159 16.0336C25.4159 13.6333 24.7672 11.6875 23.9672 11.6875C21.5669 11.6875 19.6211 13.6333 19.6211 16.0336C19.6211 18.4339 21.5669 20.3797 23.9672 20.3797C24.7672 20.3797 25.4159 18.4339 25.4159 16.0336Z",
    fill: "#1E8AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualnotary);
export default __webpack_public_path__ + "static/media/virtualnotary.20e487d794ca77b3f8375a652570a09d.svg";
export { ForwardRef as ReactComponent };